module.exports = __webpack_public_path__ + "static/media/glass-martini.c0006116.svg";